import { AxiosError, AxiosResponse } from "axios";
import moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import MessageTile from "./MessageTile";
import { MessageModel, MessageThreadModel, UserModel } from "../../models/MessageCenterModels";
import Service from "../../services";
import { APP_Config } from "../../utils/AppConfig";
import { catchError } from "../../utils/Utils";
import { getMessagesValues } from "../../data/MessageCenter";

interface MessageDisplayBoxProps {
  // contextId?: string;
  conversation: MessageThreadModel;
  setDownloadFile: React.Dispatch<any>;
  setFileLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setViewFile: React.Dispatch<React.SetStateAction<boolean>>;
  users: UserModel[] | [];
  reloadMessages: any;
}

const MessageDisplayBox = (props: MessageDisplayBoxProps) => {
  const service = useMemo(() => new Service(), []);
  const [messages, setMessages] = useState<MessageModel[] | []>([]);
  const appReloadTime = APP_Config().REACT_APP_RELOAD_TIME !== undefined ? 
    parseInt(APP_Config().REACT_APP_RELOAD_TIME) * 60 * 1000 : 0;

  const getMessages = useCallback(() => {
    if (props?.conversation?.id) {
      service
        .getMessages(props.conversation?.id)
        .then((res: AxiosResponse<MessageModel[]>) => {
          const messageArray = res?.data?.sort((a: MessageModel, b: MessageModel) => {
            return Date.parse(b.createdAt) - Date.parse(a.createdAt);
          });
          setMessages(messageArray);
        })
        .catch((error: AxiosError) => {
          catchError(error,true)
        });
    } else {
      setMessages([]);
    }
  }, [props?.conversation, service]);

  useEffect(() => {
    getMessages();
    const interval = setInterval(() => getMessages(), appReloadTime);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getMessages]);

  useEffect(() => {
    props.reloadMessages.current = getMessages;
  }, [getMessages, props.reloadMessages])

  moment.locale('en', {
    calendar: {
      lastDay: '[Yesterday] LT',
      sameDay: '[Today] LT',
      lastWeek: 'dddd LT',
      sameElse: 'L LT'
    }
  });

  return (
    <div className="messageDisplayBox">
      {messages && messages?.length > 0  ? (messages?.map((message: MessageModel) => (
        <div key={message.id} className='messageDisplay'>
        {message?.createdAt && <div className="displayDate">{moment(message.createdAt).calendar()}</div>}
          <MessageTile
            key={message.id}
            message={message}
            setDownloadFile={props.setDownloadFile}
            setViewFile={props?.setViewFile}
            setFileLoading={props.setFileLoading}
            users={props?.users || []}
            disableforsuperuser={false}
          />
        </div>
      ))) : props?.conversation?.id && (<p>No messages available.</p>)}
    </div>
  );
};

export default MessageDisplayBox;
